export const higherQuality=[
	
	
	{
		name: "the_town",
		title: "The Town   --Weeknd",
		// link:   "https://drive.google.com/uc?export=download&id=1ga8KdE7vCWgqylZSeHokvJriv1dN_gfj"
		link : 'https://od.lk/s/OF8xODc2NDU1MzNf/The%20Weeknd%20The%20Town%20Lyrics_v720P.mp4'
	},
	{
		name: "lost_in_the_echo",
		title: "Lost In The Echo   --Linkin Park",
		// link:  "https://drive.google.com/uc?export=download&id=1JCDi9zEO8rQNw7zQgks5NpJFIAG6FyV-"
		link : 'https://od.lk/s/OF8xODc2NDU1NDBf/720p%20LOST%20IN%20THE%20ECHO%20Official%20Video%20Linkin%20Park_v720P.mp4'
	},
	{	name: "start_again",
		title: "Start Again   --One Republic",
		// link:  "https://drive.google.com/uc?export=download&id=1j3mwuLl2C7XO3EeF6gdPPD0AE3Zy0qfz"
		link : 'https://od.lk/s/OF8xODc2NDU1MzZf/720p%20OneRepublic%20Start%20Again%20ft%20Logic%20Official%20Music%20Video_v720P.mp4'
	},
	{
		name: "numb",
		title: "Numb   --Linkin Park",
		link : "https://od.lk/s/OF8xODc2NDYwOTZf/Numb%20Official%20Music%20Video%204K%20UPGRADE%20Linkin%20Park_v720P.mp4"
	},
	{
		 name : 'bohemian_rhapsody',
		 title : "Bohemian Rhapsody   --Queen",
		 link : 'https://od.lk/s/OF8xODc2NDU3MjZf/Queen%20Bohemian%20Rhapsody%20Official%20Video%20Remastered_v720P.mp4'
	},
	{
		 name : 'jesus_of_suburbia',
		 title : "Jesus Of Suburbia   --Green Day",
		 link : 'https://od.lk/s/OF8xODc2NDU4MTNf/Green%20Day%20Jesus%20of%20Suburbia%20Lyrics%20HD_v720P.mp4'
	}

	
]